import { AxiosError } from "axios";

import { getPartnerToken } from "./get-partner-token";
import { gupshupIntegrationService } from "@/api/customer-platform/whatsapp/gupshup-integration";
import { apiGupShup } from "@/lib/axios";

export async function getGupshupProfilePhoto(appId: string): Promise<string | null> {
  try {
    const partnerToken = await getPartnerToken();
    const appToken = await gupshupIntegrationService.getAppToken(appId, partnerToken);

    let response;
    try {
      response = await apiGupShup.get(`/app/${appId}/business/profile/photo`, {
        headers: {
          Authorization: appToken,
        },
      });
    } catch (tokenError) {
      if (tokenError instanceof AxiosError && (tokenError.response?.status === 401 || tokenError.response?.status === 403)) {
        response = await apiGupShup.get(`/app/${appId}/business/profile/photo`, {
          headers: {
            token: appToken,
          },
        });
      } else {
        throw tokenError;
      }
    }

    const photoUrl = response.data?.message;
    if (!photoUrl || typeof photoUrl !== "string") {
      return null;
    }

    return photoUrl;
  } catch (error) {
    if (error instanceof AxiosError) {
      if (error.response?.status === 401) {
        throw new Error("UNAUTHORIZED");
      }
      if (error.response?.status === 400 || error.response?.status === 404) {
        return null;
      }
      throw new Error(
        `Failed to get profile photo: ${error.response?.data?.message || error.message}`
      );
    }
    return null;
  }
}

